// // Section: KSP
// document.addEventListener('DOMContentLoaded', function() {
//   // Initialize Swiper for the "See it in action" section with 4 slides per view
//   var seeInActionSwiper = new Swiper('.ksp-items', {
//     slidesPerView: 5,  // Maximum 4 videos in view
//     spaceBetween: 10,  // Space between each slide (optional, adjust as needed)
//     navigation: {
//       nextEl: '.ksp-scroller-next',
//       prevEl: '.ksp-scroller-prev',
//     },
//     on: {
//       init: function() {
//         updateNavButtons(this);
//       },
//       slideChange: function() {
//         updateNavButtons(this);
//       }
//     },
//     breakpoints: {
//       // Add breakpoints for responsive behavior (optional)
//       320: {
//         slidesPerView: 3,  // Mobile view, show 2 video
//       },
//       768: {
//         slidesPerView: 5,  // Tablet view, show 5 videos
//       },
//       1024: {
//         slidesPerView: 5,  // Desktop view, show 5 videos
//       }
//     }
//   });

//   // Function to update the next/prev button states
//   function updateNavButtons(swiper) {
//     var prevButton = document.querySelector('.ksp-scroller-prev');
//     var nextButton = document.querySelector('.ksp-scroller-next');

//     // Disable 'prev' button if at the first slide
//     if (swiper.isBeginning) {
//       prevButton.classList.add('disabled');
//     } else {
//       prevButton.classList.remove('disabled');
//     }

//     // Disable 'next' button if at the last slide
//     if (swiper.isEnd) {
//       nextButton.classList.add('disabled');
//     } else {
//       nextButton.classList.remove('disabled');
//     }
//   }
// });

// Section: See it in action
document.addEventListener('DOMContentLoaded', function() {
  // Initialize Swiper for the "See it in action" section with 4 slides per view
  var seeInActionSwiper = new Swiper('.see-in-action-videos', {
    slidesPerView: 4,  // Maximum 4 videos in view
    spaceBetween: 10,  // Space between each slide (optional, adjust as needed)
    navigation: {
      nextEl: '.see-in-action-scroller-next',
      prevEl: '.see-in-action-scroller-prev',
    },
    on: {
      init: function() {
        updateNavButtons(this);
      },
      slideChange: function() {
        updateNavButtons(this);
      }
    },
    breakpoints: {
      // Add breakpoints for responsive behavior (optional)
      320: {
        slidesPerView: 2,  // Mobile view, show 1 video
      },
      768: {
        slidesPerView: 4,  // Tablet view, show 2 videos
      },
      1024: {
        slidesPerView: 4,  // Desktop view, show 4 videos
      }
    }
  });

  // Function to update the next/prev button states
  function updateNavButtons(swiper) {
    var prevButton = document.querySelector('.see-in-action-scroller-prev');
    var nextButton = document.querySelector('.see-in-action-scroller-next');

    // Disable 'prev' button if at the first slide
    if (swiper.isBeginning) {
      prevButton.classList.add('disabled');
    } else {
      prevButton.classList.remove('disabled');
    }

    // Disable 'next' button if at the last slide
    if (swiper.isEnd) {
      nextButton.classList.add('disabled');
    } else {
      nextButton.classList.remove('disabled');
    }
  }
});

// SECTION: Info Blocks
document.addEventListener('DOMContentLoaded', function () {
  var infoBlocks = document.querySelectorAll('.info-block .info-title');

  infoBlocks.forEach(function (title) {
    title.addEventListener('click', function () {
      var block = this.parentElement;
      var details = block.querySelector('.info-details');

      if (block.classList.contains('open')) {
        details.style.maxHeight = null;
        block.classList.remove('open');
      } else {
        details.style.maxHeight = details.scrollHeight + 'px';
        block.classList.add('open');
      }
    });
  });
});
